import ProxyFormCreate from "../Form/ProxyFormCreate";
import ProxiesNewCsv from "./Csv/Index";

const NewProxy: React.FC = () => {
	return (
		<div className="flex flex-col gap-6">
			<ProxyFormCreate />
			<ProxiesNewCsv />
		</div>
	);
};

export default NewProxy;
